import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import './Teamslider.css';

function ImageSlider() {
  let settings = {
    dots: true,
    infinite: true,
    autoplaySpeed: 2000,
    autoplay: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      }
    ]
  }

  const [team, setTeam] = useState([])
  const fetchTeam = async () => {
    await fetch("https://api.aizonixsolutions.com/api/team/")
      .then((res) => res.json())
      .then((team) => setTeam(team))
      .catch((err) => {
        console.log(err)
      })
  }
  useEffect(() => {
    fetchTeam();
  }, [])

  return (
    <div className='mainbody'>
      <h5 style={{ textAlign: 'center', color: "#1E978C" }}>Leadership </h5>
      <h1>Our Team</h1>
      <Slider {...settings}>
        {team.map((user) => (
          <div key={user.id} className="card-wrapper">
            <ul className="card">
              <li className="card-image">
                <img src={user.profile_pic} alt="Profile Pic" />
              </li>
              <li className="details">
                <h2>{user.Name}<span className="job-title">{user.Designation}</span></h2>
              </li>
            </ul>
          </div>
        ))}
      </Slider>
    </div>
  )
}

export default ImageSlider

